import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  exportExcel(fileName: string, data: any[], headers: {[key: string]: string}) {
    // Prepare data with clean headers
    const cleanData = data.map((item, index) => {
      const row: any = {'#': index + 1};
      Object.keys(headers).forEach(key => {
        // Handle date formatting
        if ((key.toLowerCase().includes('date') || headers[key].includes('تاريخ')) && item[key] && typeof item[key] === 'string' && item[key].includes('T')) {
          row[headers[key]] = item[key].split('T')[0];
        } else {
          row[headers[key]] = item[key];
        }
      });
      return row;
    });

    // Create worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(cleanData);
    
    // Define styles (exactly like your original)
    const headerStyle = {
      font: { bold: true, sz: 14, color: { rgb: 'FFFFFF' } },
      fill: { fgColor: { rgb: '4F81BD' } },
      alignment: { horizontal: 'center', vertical: 'center' },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } }
      }
    };

    const titleStyle = {
      font: { bold: true, sz: 12, color: { rgb: '000000' } },
      fill: { fgColor: { rgb: 'FFFF00' } },
      alignment: { horizontal: 'center', vertical: 'center' },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } }
      }
    };

    const dataStyleOdd = {
      fill: { fgColor: { rgb: 'D3D3D3' } },
      alignment: { horizontal: 'center' },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } }
      }
    };

    const dataStyleEven = {
      fill: { fgColor: { rgb: 'FFFFFF' } },
      alignment: { horizontal: 'center' },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } }
      }
    };

    // Apply header style (row 1)
    const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1:Z1');
    for(let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ c: C, r: range.s.r });
      if(!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = headerStyle;
    }

    // Apply alternating row styles to data
    const dataRange = XLSX.utils.decode_range(worksheet['!ref'] || 'A1:Z100');
    for(let R = dataRange.s.r + 1; R <= dataRange.e.r; ++R) {
      for(let C = dataRange.s.c; C <= dataRange.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ c: C, r: R });
        if(!worksheet[cellAddress]) continue;
        
        // Apply odd/even row styling
        worksheet[cellAddress].s = R % 2 === 0 ? dataStyleEven : dataStyleOdd;
      }
    }

   // Set right-to-left direction for the sheet
    worksheet['!views'] = [{ rightToLeft: true }];
  
    // Create workbook
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data']
    };
    
    // Generate and save Excel file
    const excelBuffer: any = XLSX.write(workbook, { 
      bookType: 'xlsx', 
      type: 'array' 
    });
    
    // Add current date to filename (like your original)
    const now = new Date();
    const currentDate = now.getFullYear() + '-' + 
      (now.getMonth() + 1).toString().padStart(2, '0') + '-' + 
      now.getDate().toString().padStart(2, '0');
    const fullFileName = fileName + ' - ' + currentDate;
    
    this.saveAsExcelFile(excelBuffer, fullFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, `${fileName}.xlsx`);
  }
}